import PublicRoute from './public-route';
import PrivateRoute from './private-route';
import Editor from './editor'
import PostTemplate from './template'
export {
  PublicRoute,
  PrivateRoute,
  Editor,
  PostTemplate
}